import i18next from 'i18next';
import XHR from 'i18next-xhr-backend';
import BackendAdapter from 'i18next-multiload-backend-adapter';
import { SERVER_URL } from '../config';
import { chainId } from '../cache';
import store from '../store';
import { changeLanguage } from '../actions';
import localResources from './local-resources';

const localOnly = !chainId;
const languages = Object.keys(localResources);

let defaultLang = (localStorage.getItem('language') || window.navigator.userLanguage || window.navigator.language || languages[0]).split('-')[0];
if (!languages.includes(defaultLang)) defaultLang = languages[0];

const options = {
    ns: ['website', 'common', 'local'],
    fallbackNS: ['website', 'common', 'local'],
    defaultNS: 'website',

    lng: defaultLang,

    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },

    react: {
        wait: true
    },
};

if (!localOnly) {
    options.backend = {
        backend: XHR,
        backendOption: {
            loadPath: `${SERVER_URL}locales/website?languages=${languages.join(',')}&chainId=${chainId}`,
            allowMultiLoading: true,
        }
    };

    i18next.use(BackendAdapter);
}

i18next.init(options).finally(() => {
    store.dispatch(changeLanguage(defaultLang, true));
});

i18next.addResourceBundle('en', 'local', localResources.en);
i18next.addResourceBundle('he', 'local', localResources.he);

export default i18next;

